import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: "Ambient helped me become my mother's certified caregiver. The process was so fast and they handled everything. Now I get to care for her professionally.",
    author: 'Maria R.',
    role: 'Family Caregiver',
    image: 'https://i.pravatar.cc/150?img=44'
  }, {
    quote: 'I was nervous about hiring a stranger for my father. Ambient let me choose my own niece and got her trained in two days. Best decision we ever made.',
    author: 'James T.',
    role: 'Family Member',
    image: 'https://i.pravatar.cc/150?img=11'
  }, {
    quote: 'The team at Ambient made the entire process seamless. From background checks to CPR training, they took care of it all on-site. Highly recommend!',
    author: 'Sandra L.',
    role: 'Family Caregiver',
    image: 'https://i.pravatar.cc/150?img=5'
  }];
  return <section className="py-24 px-4 bg-accent-light/30" data-id="element-243">
      <div className="max-w-7xl mx-auto" data-id="element-244">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-245">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-heading font-bold text-neutral-dark mb-4" data-id="element-246">
            What Families Are Saying
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-neutral-medium" data-id="element-247">
            Real stories from families who chose the Ambient Family Caregiver
            Model.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-248">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-249">
              <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-accent/20" data-id="element-250" />

              <div className="flex items-center gap-1 mb-6" data-id="element-251">
                {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-accent fill-current" viewBox="0 0 20 20" data-id="element-252">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-253" />
                  </svg>)}
              </div>

              <p className="text-neutral-dark mb-8 text-lg leading-relaxed italic" data-id="element-254">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-255">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-primary/20" data-id="element-256" />
                <div data-id="element-257">
                  <h4 className="font-bold text-neutral-dark" data-id="element-258">
                    {testimonial.author}
                  </h4>
                  <p className="text-sm text-neutral-medium" data-id="element-259">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}